import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-billing-cards',
    templateUrl: './billing-cards.component.html',
    styleUrls: ['./billing-cards.component.scss'],
    standalone: false
})
export class BillingCardsComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
    
  }

}
